export default function callbackForm({ main, on, elm, state, publish }) {
	main(_ => {
		on('form-validation:submit', 'form', confirm);
	});

	const confirm = async function (e, { data }) {
		const {language} = state.get();
		const action = `index.php?route=extension/evasota/module/form_submission.submit&language=${language}`;
		const formData = new FormData();

		Object.entries(data).forEach(([key, value]) => {
			formData.append(key, value);
		});
		formData.append('page_url', location.href);

		try {
			state.set(s => s.loading = true);
			const response = await fetch(action, {
				method: 'POST',
				body: formData,
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				}
			});

			if (!response.ok) {
				throw new Error(`Request failed: ${response.status}`);
			}

			const result = await response.json();
			publish('callback-form:response', result);
		} catch (e) {
			console.error(e);
		} finally {
			state.set(s => s.loading = false);
		}
	};
};

export const model = {};
